import ReactDOM from "react-dom/client";
import React from "react";
import EntreprisesPage from "./components/EntreprisesPage.tsx";
import '../../i18n/i18n'; // Initialize i18n

const entreprisePageRoot = document.querySelector<HTMLElement>('#entreprises-page-root');
if (entreprisePageRoot) {
  ReactDOM.createRoot(entreprisePageRoot).render(
    <React.StrictMode>
      <EntreprisesPage/>
    </React.StrictMode>
  );
}